var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Component, Prop, html, directive, AttributePart, svg } from '@sick-davinci/ce-decorators';
import { style } from './BreadcrumbItem.style';
const ifTruthy = directive(value => part => {
  if (!value && part instanceof AttributePart) {
    if (value !== part.value) {
      const name = part.committer.name;
      part.committer.element.removeAttribute(name);
    }
  } else {
    part.setValue(value);
  }
});
/**
 * A `davinci-breadcrumb-item` links to a page.
 * It's a part of a `davinci-breadcrumb` to navigate quickly within page hierarchy.
 * 
 * @example
 * ```html
 * <davinci-breadcrumb>
 *    <davinci-breadcrumb-item href="/home" label="Home"></davinci-breadcrumb-item>
 *    <davinci-breadcrumb-item label="Search" onclick="console.log('clicked')"></davinci-breadcrumb-item>
 * </davinci-breadcrumb>
 * ```
 */

export let BreadcrumbItem = (_dec = Component({
  tag: 'davinci-breadcrumb-item',
  style: [style]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec(_class = (_class2 = class BreadcrumbItem extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "label", _descriptor, this);

    _initializerDefineProperty(this, "href", _descriptor2, this);
  }

  render() {
    return html`
      ${svg`
      <svg id="icon" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1">
          <polygon id="Shape" points="8.59 16.6464 13.17 12.24 8.59 7.8336 10 6.48 16 12.24 10 18"></polygon>
        </g>
      </svg>`}
      <a href="${ifTruthy(this.href)}" class="breadcrumb-item" >${this.label}</a>
    `;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "href", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
})), _class2)) || _class);
